import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { BRAND_CONSTRAINTS } from './constraints.js';
export const createBrandInputSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, `${BRAND_CONSTRAINTS.name.label} is required`)
        .max(BRAND_CONSTRAINTS.name.maxLength, `${BRAND_CONSTRAINTS.name.label} must be ${BRAND_CONSTRAINTS.name.maxLength} characters or fewer`),
    companyId: requiredUuidString('Company is required', 'Invalid company selection.'),
});
//# sourceMappingURL=create-input.js.map